const collator = new Intl.Collator(undefined, { sensitivity: 'base' });

export function sortPickerByLabel<T extends { label: string }>(choices: readonly T[]): T[] {
  return [...choices].sort((a, b) => collator.compare(a.label, b.label));
}

export function sortPagesByName<T extends { name: string }>(pages: readonly T[]): T[] {
  return [...pages].sort((a, b) => collator.compare(a.name, b.name));
}

export function sortSectionsByTitle<T extends { title: string }>(sections: readonly T[]): T[] {
  return [...sections].sort((a, b) => collator.compare(a.title, b.title));
}
